import React from 'react';
import Layout from '../components/Layout'; // Importa o Layout
import { PageProps } from '../App'; // Importa a interface PageProps

// Adiciona PageProps à definição do componente
const RecursosPage: React.FC<PageProps> = ({ darkMode, toggleDarkMode }) => {
  return (
    // Passa as props para o Layout
    <Layout darkMode={darkMode} toggleDarkMode={toggleDarkMode}>
      <div className="bg-white dark:bg-gray-900">
        {/* Hero Section */}
        <div className="relative hero-gradient overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-lupa-purple-dark/70 to-lupa-purple/30 z-10"></div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-20">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight font-heading">
                Recursos
              </h1>
              <p className="mt-6 text-xl text-white/90 max-w-3xl mx-auto">
                Materiais educativos e ferramentas para ajudar você a aproveitar ao máximo seus dados.
              </p>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
              <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,149.3C960,160,1056,160,1152,138.7C1248,117,1344,75,1392,53.3L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
          </div>
        </div>

        {/* Conteúdo Principal */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-4">Conhecimento é Poder</h2>
            <p className="text-xl text-gray-700 dark:text-gray-300 max-w-3xl mx-auto">
              Explore nossa biblioteca de recursos educativos sobre dados, IA, machine learning e tecnologias relacionadas. 
              Estes materiais foram desenvolvidos por nossos especialistas para ajudar você a entender melhor o mundo dos dados.
            </p>
          </div>

          {/* eBooks */}
          <div className="mb-20">
            <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-8">eBooks</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* eBook 1 */}
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                  <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Guia Completo de Data Lakes</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Aprenda tudo sobre Data Lakes, desde conceitos básicos até implementações avançadas, 
                    com exemplos práticos e melhores práticas.
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500 dark:text-gray-400">32 páginas</span>
                    <a href="#" className="text-lupa-orange font-medium hover:underline">Download</a>
                  </div>
                </div>
              </div>

              {/* eBook 2 */}
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                  <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Introdução à IA para Negócios</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Um guia prático sobre como a Inteligência Artificial pode transformar seu negócio, 
                    com casos de uso reais e estratégias de implementação.
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500 dark:text-gray-400">45 páginas</span>
                    <a href="#" className="text-lupa-orange font-medium hover:underline">Download</a>
                  </div>
                </div>
              </div>

              {/* eBook 3 */}
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                  <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Governança de Dados na Era Digital</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Descubra como implementar uma estratégia eficaz de governança de dados, 
                    garantindo conformidade, segurança e qualidade.
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500 dark:text-gray-400">38 páginas</span>
                    <a href="#" className="text-lupa-orange font-medium hover:underline">Download</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Whitepapers */}
          <div className="mb-20">
            <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-8">Whitepapers</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Whitepaper 1 */}
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-lupa-orange rounded-full flex items-center justify-center">
                      <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Arquiteturas Data Lakehouse: O Futuro do Armazenamento de Dados</h3>
                    <p className="text-gray-700 dark:text-gray-300 mb-4">
                      Uma análise técnica aprofundada sobre como as arquiteturas Data Lakehouse estão revolucionando 
                      a maneira como as empresas armazenam e processam dados.
                    </p>
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-500 dark:text-gray-400">Técnico</span>
                      <a href="#" className="text-lupa-orange font-medium hover:underline">Download</a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Whitepaper 2 */}
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-lupa-orange rounded-full flex items-center justify-center">
                      <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">ROI de Projetos de IA: Métricas e Metodologias</h3>
                    <p className="text-gray-700 dark:text-gray-300 mb-4">
                      Um guia detalhado sobre como medir o retorno sobre investimento em projetos de IA, 
                      com metodologias práticas e estudos de caso.
                    </p>
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-500 dark:text-gray-400">Estratégico</span>
                      <a href="#" className="text-lupa-orange font-medium hover:underline">Download</a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Whitepaper 3 */}
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-lupa-orange rounded-full flex items-center justify-center">
                      <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Segurança e Privacidade em Ambientes de Big Data</h3>
                    <p className="text-gray-700 dark:text-gray-300 mb-4">
                      Uma análise abrangente sobre os desafios e soluções para garantir segurança e privacidade 
                      em ambientes de Big Data, incluindo conformidade com LGPD e GDPR.
                    </p>
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-500 dark:text-gray-400">Técnico</span>
                      <a href="#" className="text-lupa-orange font-medium hover:underline">Download</a>
                    </div>
                  </div>
                </div>
              </div>

              {/* Whitepaper 4 */}
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="flex items-start">
                  <div className="flex-shrink-0">
                    <div className="w-12 h-12 bg-lupa-orange rounded-full flex items-center justify-center">
                      <svg className="h-6 w-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4">
                    <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Cultura Data-Driven: Transformando Organizações</h3>
                    <p className="text-gray-700 dark:text-gray-300 mb-4">
                      Um guia estratégico sobre como criar e nutrir uma cultura orientada a dados em sua organização, 
                      com foco em pessoas, processos e tecnologia.
                    </p>
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-500 dark:text-gray-400">Estratégico</span>
                      <a href="#" className="text-lupa-orange font-medium hover:underline">Download</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Webinars 
          <div className="mb-20">
            <h2 className="text-2xl font-bold text-lupa-purple dark:text-white mb-8">Webinars</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {/* Webinar 1 
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="h-48 bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
                  <svg className="h-24 w-24 text-gray-400 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Implementando Data Lakes na Prática</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Neste webinar, nossos especialistas mostram passo a passo como implementar um Data Lake 
                    eficiente, desde a arquitetura até a operacionalização.
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500 dark:text-gray-400">60 minutos</span>
                    <a href="#" className="text-lupa-orange font-medium hover:underline">Assistir</a>
                  </div>
                </div>
              </div>

              {/* Webinar 2 
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="h-48 bg-gray-200 dark:bg-gray-700 flex items-center justify-center">
                  <svg className="h-24 w-24 text-gray-400 dark:text-gray-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                  </svg>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Machine Learning para Não-Técnicos</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Uma introdução acessível ao mundo do Machine Learning, explicando conceitos complexos 
                    de forma simples e mostrando aplicações práticas para negócios.
                  </p>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-500 dark:text-gray-400">45 minutos</span>
                    <a href="#" className="text-lupa-orange font-medium hover:underline">Assistir</a>
                  </div>
                </div>
              </div>
            </div>
          </div>


          {/* Call to Action Final */}
          <div className="mt-20 text-center bg-gray-100 dark:bg-gray-800 p-12 rounded-xl shadow-inner">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-4">Quer Receber Nossos Materiais?</h2>
            <p className="text-lg text-gray-700 dark:text-gray-300 mb-8 max-w-2xl mx-auto">
              Inscreva-se em nossa newsletter para receber os mais recentes recursos, webinars e eventos diretamente em seu e-mail.
            </p>
            <a href="/contato" className="btn-primary text-lg">
              Inscrever-se
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default RecursosPage;
